import React from 'react';
import PageWrapper from '../wrappers/page-wrapper';

const Login = () => <div style={{'display':'flex','justifyContent': 'center',
'padding': '30px'}}>LOGIN PAGE COMING UP...</div>

Login.getInitialProps = () => { return {loginState: {}} };
Login.domainName = 'attract-accelerate';

export default PageWrapper(Login);